export default function buildObjectFromArray(
  values: string[] = [],
  propValuePart = '',
  propKeyPart = '',
): Record<string, string> {
  const result: Record<string, string> = {};

  for (const val of values) {
    result[`${propKeyPart}${val}`] = `${propValuePart}${val}`;
  }

  return result;
}
